import { Paragraph, Progress } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';

interface SettlementProgressProps {
  value: number;
  max: number;
  isBoosted?: boolean;
  className?: string;
}

export const SettlementProgress = ({ value, max, className }: SettlementProgressProps) => {
  return (
    <div className={cn('relative', className)}>
      <Progress
        value={value}
        max={max}
        indicatorColor="orange"
        className="min-w-[100px] h-[10px]"
      />
      <Paragraph
        size="2xs"
        variant="white"
        className="text-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      >
        {value}/{max}
      </Paragraph>
    </div>
  );
};
